// src/components/custom-select/styles.ts
import styled from "styled-components";
import { Select } from "@mui/material";
import theme from "../../../../styles/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Roboto", sans-serif;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 16px;
  color: #5f6368;
  margin-left: 4px;
`;

export const StyledSelect = styled(Select)`
  .MuiOutlinedInput-root {
    font-family: "Roboto", sans-serif;
    height: 38px;
    border-radius: 24px;
    background-color: #ffffff;
    transition: border-color 0.2s ease;

    & .MuiOutlinedInput-notchedOutline {
      border-color: #8e8e8e;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #5f6368;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-width: 2px;
      border-color: ${theme.colors.blue.primary};
    }
  }

  .MuiSelect-select {
    padding-right: 48px; /* Espaço para o ícone */
  }

  .MuiSelect-icon {
    color: #5f6368;
    right: 12px;
  }
`;
